import { render } from "./InfoCard.vue?vue&type=template&id=278463e4&scoped=true&ts=true"
import script from "./InfoCard.vue?vue&type=script&lang=ts"
export * from "./InfoCard.vue?vue&type=script&lang=ts"

import "./InfoCard.vue?vue&type=style&index=0&id=278463e4&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278463e4"],['__file',"src/components/InfoCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "278463e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('278463e4', __exports__)) {
    api.reload('278463e4', __exports__)
  }
  
  module.hot.accept("./InfoCard.vue?vue&type=template&id=278463e4&scoped=true&ts=true", () => {
    api.rerender('278463e4', render)
  })

}


export default __exports__